export const EnvConfig = {
  MODE: process.env.REACT_APP_MODE,
  API_URL:
    process.env.REACT_APP_IS_BETA === "true"
      ? process.env.REACT_APP_BETA_URL
      : process.env.REACT_APP_CORE_URL,
  HUB_URL: localStorage.getItem("battleURL") ||
    (process.env.REACT_APP_IS_BETA === "true" ? process.env.REACT_APP_BETA_HUB_URL : process.env.REACT_APP_HUB_URL),
};
  